export const INFO_ICON_URL = `${process.env.REACT_APP_CdnBaseUrl}/knowledgepoint/InfoCircle.svg`

export const MANUFACTURER_OPTION = 'Manufacturer option'
export const MASTERSPEC_OPTION = 'MasterSpec option'
export const PROPERTY_VALUE = 'Property value'

export declare type TextVariant = keyof typeof PROPERTY_EDITOR_EDITABLE_TEXT_VARIANT
export const PROPERTY_EDITOR_EDITABLE_TEXT_VARIANT = {
    boxed: 'boxed',
    plain: 'plain',
    newlyadded: 'newlyadded',
    newPill: 'newPill',
    newReplacement: 'newReplacement',
    newUOM: 'newUOM',
    uomInPill: 'uomInPill',
    ReplacementOption: 'ReplacementOption',
    UnitsOfMeasure: 'UnitsOfMeasure',
    Text: 'Text',
    NewlyAdded: 'NewlyAdded',
    Hyperlink: 'Hyperlink',
    SelectionOption: 'SelectionOption',
    Article: 'Article',
    Part: 'Part',
    Paragraph: 'Paragraph',
    OptionGroup: 'OptionGroup',
    SpecifierNote: 'SpecifierNote',
    AssemblyText: 'AssemblyText',
    Table: 'Table',
} as const

export const PROPERTY_EDITOR_TEXT_FORMAT_TYPE = {
    add: 'add',
    delete: 'delete',
    replace: 'replace',
} as const

// Keyboard event/shortcut mapping for PropertyEditorEditableText and ProjectButton component
// declared 'as const' type to make sure object is readonly and can only be modified on this constants.ts file
export const PROPERTY_EDITOR_SHORTCUT_KEY_MAPPING = {
    AddSpecifierNote: 'Ctrl+Alt+S',
    Alt: 'Alt',
    ArrowDown: 'ArrowDown',
    ArrowLeft: 'ArrowLeft',
    ArrowRight: 'ArrowRight',
    ArrowUp: 'ArrowUp',
    Backspace: 'Backspace',
    Close: 'Ctrl+X',
    Control: 'Control',
    Copy: 'Ctrl+C',
    CopyPT: 'Ctrl+Alt+C',
    Delete: 'Delete',
    Demote: 'Tab',
    Enter: 'Enter',
    Escape: 'Escape',
    Export: 'Ctrl+Shift+E', // deprecated: for old workspace editor
    ExportWord: 'Ctrl+Alt+W',
    ExportPDF: 'Ctrl+Alt+D',
    InsertPill: 'Ctrl+Alt+P', // deprecated: ctrl+[
    InsertText: 'Ctrl+Alt+T', // deprecated: ctrl+shift+<
    InsertUOM: 'Ctrl+U', // deprecated: ctrl+shift+>
    MoveDown: 'Alt+Shift+Arrow Down',
    MoveUp: 'Alt+Shift+Arrow Up',
    Preview: 'Ctrl+Alt+I',
    Preview2: 'Ctrl+Alt+R', // for new workspace editor
    Promote: 'Shift+Tab',
    Save: 'Ctrl+S',
    SelectAll: 'Ctrl+A',
    Shift: 'Shift',
    Space: ' ',
    SupportingDocs: 'Ctrl+I',
    Evaluations: 'Ctrl+Alt+E',
    Tab: 'Tab',
    Undo: 'Ctrl+Z',
} as const

export const ActionButtonVariant = {
    Demote: 'Demote',
    CopyProductType: 'CopyProductType',
    Export: 'Export',
    Hide: 'Hide',
    MoveDown: 'MoveDown',
    MoveUp: 'MoveUp',
    InsertPill: 'InsertPill',
    Preview: 'Preview',
    Promote: 'Promote',
    SpecifierNote: 'SpecifierNote',
    SupportingDocuments: 'SupportingDocuments',
    InsertText: 'InsertText',
    InsertUOM: 'InsertUOM',
    Delete: 'Delete',
    RenameVersions: 'RenameVersions',
    Settings: 'Settings',
} as const

export const PART_TYPES = {
    GENERAL: 'GENERAL',
    PRODUCTS: 'PRODUCTS',
    EXECUTION: 'EXECUTION',
} as const

export const SuggestionTypeLookup: Record<string, string> = {
    ADDED: 'insertion',
    DELETED: 'deletion',
    INSERTION: 'ADDED',
    DELETION: 'DELETED',
    MODIFIED: 'MODIFIED',
    DISABLED: 'DISABLED',
} as const

export const MANUFACTURERBOD_PLACEHOLDERS = {
    APPROVED_MANUFACTURERS: 'Approved Manufacturers',
    APPROVED_PRODUCTS: 'Approved Products',
    BOD0: 'Basis of Design',
    BOD1: 'Basis-of-Design',
    BOD2: 'Basis-Of-Design',
    BOD3: 'Basis of Design Product',
    BOD4: 'Basis-of-Design Product',
    BOD5: 'Basis-Of-Design Product',
    MANUFACTURER: 'Manufacturer',
    MANUFACTURERS: 'Manufacturers',
    PRODUCT: 'Product',
    PRODUCTS: 'Products',
} as const

export const ElementType = {
    SUSTAINABILITY: 'SUSTAINABILITY',
    PRODUCTTYPE: 'PRODUCTTYPE',
    DEFAULT: 'DEFAULT',
    PRODUCTFAMILY: 'PRODUCTFAMILY',
} as const

export const ElementTreeViews = {
    Divisions: 'Divisions',
    Assemblies: 'Assemblies',
} as const

export const PartTypes = {
    CONTENT_GROUP: 'ContentGroup',
} as const
